import React, { PropTypes } from 'react';

import './Modal.css';

const itemShape = {
  name: PropTypes.string.isRequired
}

const propTypes = {
  item: PropTypes.shape(itemShape),
  onAction: PropTypes.func.isRequired
}

const Modal = ({ item, onAction }) => {
  const message = item ? `Delete list '${item.name}'?` : '';

  return (
    <div className={item ? 'Modal Modal-open' : 'Modal'} onClick={() => onAction(false, item)}>
      <div className='Modal-inner' onClick={event => event.stopPropagation()}>
        <h3>{message}</h3>
        <div className="Modal-actions clearfix">
          <button onClick={() => onAction(true, item)}>OK</button>
          <button onClick={() => onAction(false, item)}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

Modal.propTypes = propTypes;

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/components/Modal.js
 **/